import { render, staticRenderFns } from "./BaseMultiImageUploadInput.vue?vue&type=template&id=2d346fa6&scoped=true"
import script from "./BaseMultiImageUploadInput.vue?vue&type=script&lang=js"
export * from "./BaseMultiImageUploadInput.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiImageUploadInput.vue?vue&type=style&index=0&id=2d346fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d346fa6",
  null
  
)

export default component.exports